/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subscription_Service_Level_Compare_Timer_TitleInputs */

const en_subscription_service_level_compare_timer_title = /** @type {(inputs: Subscription_Service_Level_Compare_Timer_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Timer and Focus Stats`)
};

const ar_subscription_service_level_compare_timer_title = /** @type {(inputs: Subscription_Service_Level_Compare_Timer_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إحصائيات المؤقت والتركيز`)
};

const de_subscription_service_level_compare_timer_title = /** @type {(inputs: Subscription_Service_Level_Compare_Timer_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Timer und Fokus-Statistiken`)
};

const es_subscription_service_level_compare_timer_title = /** @type {(inputs: Subscription_Service_Level_Compare_Timer_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Temporizador y estadísticas de concentración`)
};

const fr_subscription_service_level_compare_timer_title = /** @type {(inputs: Subscription_Service_Level_Compare_Timer_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minuteur et statistiques de concentration`)
};

const it_subscription_service_level_compare_timer_title = /** @type {(inputs: Subscription_Service_Level_Compare_Timer_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Statistiche timer e concentrazione`)
};

const ja_subscription_service_level_compare_timer_title = /** @type {(inputs: Subscription_Service_Level_Compare_Timer_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`タイマーと集中時間の統計`)
};

const ko_subscription_service_level_compare_timer_title = /** @type {(inputs: Subscription_Service_Level_Compare_Timer_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`타이머 및 집중 통계`)
};

const pt_br_subscription_service_level_compare_timer_title = /** @type {(inputs: Subscription_Service_Level_Compare_Timer_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estatísticas de tempo e foco`)
};

const ru_subscription_service_level_compare_timer_title = /** @type {(inputs: Subscription_Service_Level_Compare_Timer_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Статистика времени и фокусировки`)
};

const th_subscription_service_level_compare_timer_title = /** @type {(inputs: Subscription_Service_Level_Compare_Timer_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ตัวจับเวลาและสถิติการโฟกัส`)
};

const tr_subscription_service_level_compare_timer_title = /** @type {(inputs: Subscription_Service_Level_Compare_Timer_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zamanlayıcı ve Odaklanma İstatistikleri`)
};

const zh_cn_subscription_service_level_compare_timer_title = /** @type {(inputs: Subscription_Service_Level_Compare_Timer_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`计时与专注统计`)
};

const zh_tw_subscription_service_level_compare_timer_title = /** @type {(inputs: Subscription_Service_Level_Compare_Timer_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`計時與專注統計`)
};

/**
* | output |
* | --- |
* | "Timer and Focus Stats" |
*
* @param {Subscription_Service_Level_Compare_Timer_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const subscription_service_level_compare_timer_title = /** @type {((inputs?: Subscription_Service_Level_Compare_Timer_TitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subscription_Service_Level_Compare_Timer_TitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_subscription_service_level_compare_timer_title(inputs)
	if (locale === "ar") return ar_subscription_service_level_compare_timer_title(inputs)
	if (locale === "de") return de_subscription_service_level_compare_timer_title(inputs)
	if (locale === "es") return es_subscription_service_level_compare_timer_title(inputs)
	if (locale === "fr") return fr_subscription_service_level_compare_timer_title(inputs)
	if (locale === "it") return it_subscription_service_level_compare_timer_title(inputs)
	if (locale === "ja") return ja_subscription_service_level_compare_timer_title(inputs)
	if (locale === "ko") return ko_subscription_service_level_compare_timer_title(inputs)
	if (locale === "pt_br") return pt_br_subscription_service_level_compare_timer_title(inputs)
	if (locale === "ru") return ru_subscription_service_level_compare_timer_title(inputs)
	if (locale === "th") return th_subscription_service_level_compare_timer_title(inputs)
	if (locale === "tr") return tr_subscription_service_level_compare_timer_title(inputs)
	if (locale === "zh_cn") return zh_cn_subscription_service_level_compare_timer_title(inputs)
	return zh_tw_subscription_service_level_compare_timer_title(inputs)
});